export default {
  effect() {
     console.log("公用的方法")
    },
}
